<template>
    <div class="city">
        <List class="listClass" border @click.native="show = true">
            <ListItem v-if="fieldValue" style="color: #515a6e;">{{fieldValue}}</ListItem>
            <ListItem v-else>区域选择</ListItem>
        </List>
        <van-popup v-model="show" round position="bottom">
            <van-cascader v-show="show" style="font-size:0.8rem;" v-model="cascaderValue" title="请选择所在地区"
                :options="options" @close="show = false" @change="onChange" @finish="onFinish" />
        </van-popup>
    </div>
</template>
<script>
import 'vant/lib/cascader/style/less';
import 'vant/lib/field/style/less';
import 'vant/lib/popup/style/less';
export default {
    data() {
        return {
            data: [],
            show: false,
            fieldValue: '',
            cascaderValue: '',
            // 选项列表，children 代表子选项，支持多级嵌套
            options: [
            ],
        }
    },
    methods: {
        onFinish({ selectedOptions }) {
            this.show = false;
            this.$emit('listenCity', selectedOptions);
            this.fieldValue = selectedOptions.map((option) => option.text).join('/');
        },
        onChange(item) {
            this.loadCity(item)
        },
        loadCity(item) {
            const { value, selectedOptions, tabIndex } = item
            const provinceKey = this.options.findIndex(r => r.value === selectedOptions[0].value)
            if (
                selectedOptions.length === 1
            ) {
                // 获取二级
                let url = ''
                if (this.options[provinceKey].level === 1) {
                    url = '/base/job/location/queryCityByProvinceCode/' + value;
                } else {
                    // 针对北京的二级
                    url = '/base/job/location/queryAreaByCityCode/' + value;
                }

                this.$get(url).then(res => {
                    if (res.code == 0) {
                        let oData = res.data;
                        let childrenList = []
                        for (var i = 0; i < oData.length; i++) {
                            if (oData[i].isSublevel) {
                                childrenList.push({
                                    value: oData[i].code,
                                    text: oData[i].name,
                                    children: [],
                                    level: oData[i].level
                                })
                            } else {
                                childrenList.push({
                                    value: oData[i].code,
                                    text: oData[i].name,
                                    level: oData[i].level
                                })
                            }
                        }
                        this.options[provinceKey].children = childrenList
                    }
                })
            } else if (
                selectedOptions.length === 2
            ) {
                // 获取三级
                console.log('获取三级', item)
                const childrenList = []
                const cityKey = this.options[provinceKey].children.findIndex(r => r.value === selectedOptions[1].value)
                let url = '/base/job/location/queryAreaByCityCode/' + value;
                this.$get(url).then(res => {
                    let oData = res.data;
                    if (res.code == 0) {
                        if (oData != null) {
                            for (var i = 0; i < oData.length; i++) {
                                childrenList.push({
                                    value: oData[i].code,
                                    text: oData[i].name,
                                    level: oData[i].level
                                })
                            }
                            this.options[provinceKey].children[cityKey].children = childrenList
                        } else {
                            for (var i = 0; i < this.options.length; i++) {
                                if (value == this.options[provinceKey].value) {
                                    this.options[provinceKey] = {
                                        value: this.options[provinceKey].value,
                                        text: this.options[provinceKey].label,
                                        level: oData[i].level
                                    }
                                }
                            }
                        }

                    }
                })
            }
        },
        //搜索条件省市区接口
        getAllProvince() {
            let url = '/base/job/location/queryAllProvinces';
            this.$get(url).then(res => {
                if (res.code == 0) {
                    res.data.forEach((item, index) => {
                        if (!item.isSublevel) {
                            this.options.push({
                                value: String(item.code),
                                text: item.name,
                                level: item.level
                            })
                        } else {
                            this.options.push({
                                value: String(item.code),
                                text: item.name,
                                children: [],
                                loading: false,
                                level: item.level
                            })
                        }
                    })
                }
            })
        },
        clearSelect() {
            this.fieldValue = '';
            this.cascaderValue = '';
        }
    },
    mounted() {
        this.getAllProvince();
    },
}
</script>
<style lang="scss" scoped>
.city {
    /deep/ .van-cascader__title {
        font-size: 1rem;
    }

    /deep/ .van-tab__text {
        font-size: 1rem;
    }

    /deep/ .van-cascader__title {
        font-size: 1rem;
    }

    /deep/ .van-cascader__tab {
        font-size: 1rem;
    }

    /deep/ .van-cascader__option {
        font-size: 1rem;
        height: 80px;
    }

    /deep/ .van-cascader__header {
        height: 80px;
        font-size: 1rem;
    }

    /deep/ .van-cascader__tabs.van-tabs--line .van-tabs__wrap {
        height: 100px;
    }

    /deep/ .van-cascader__options {
        height: 24rem;
    }


    .listClass {
        margin-top: 15px;
        color: #969799;
        font-size: .75rem;
        text-indent: -15px;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/uploadIntelligence/components/city.vue